import type { ThemeColorPalette, ThemeColors } from "./theme-colors.type";

import { toCamelCase } from "@/utilities/string";

const generateCustomColor = (
  colorValues: ThemeColorPalette,
  colorName: string
) => {
  return Object.entries(colorValues).reduce((color, [colorKey, colorValue]) => {
    const key = toCamelCase(`${colorName}-${colorKey}`);
    return { ...color, [key]: colorValue };
  }, {});
};

export const generateCustomColors = (colors: ThemeColors) => {
  return Object.entries(colors).reduce(
    (colors, [colorName, colorValues]) => ({
      ...colors,
      ...generateCustomColor(colorValues, colorName),
    }),
    {}
  );
};
